import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { AiSummary } from '../aiSummary';

import { ChangeAmbassadorDisclosure } from './components/ChangeAmbassadorDisclosure';
import { DescriptionContent } from './components/DescriptionContent';

export const DescriptionSunriseContainer: React.FC = () => {
	const {
		data: {
			experiments: { aiSummaries },
		},
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: {
				isAmbassadorPetition,
				user: { displayName },
			},
		},
	} = usePetitionDetailsPageData();

	return (
		<div data-qa="description-section">
			<Text as="h2" className="mb-10" size="x-large" fontWeight="normal" variant="heading">
				<Translate value="corgi.petition_gamma.details.description_title" />
			</Text>

			{aiSummaries && <AiSummary />}

			<DescriptionContent />

			{isAmbassadorPetition && <ChangeAmbassadorDisclosure starterName={displayName} />}
		</div>
	);
};
